"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PavementObstruction = function PavementObstruction(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M18.5 18.5V16.207L19.3532 15.3539L19.3538 15.3532L21.3532 13.3539C21.3997 13.3074 21.4366 13.2523 21.4618 13.1916C21.4869 13.1309 21.4999 13.0658 21.4999 13.0001C21.4999 12.9344 21.487 12.8694 21.4619 12.8086C21.4367 12.7479 21.3998 12.6928 21.3534 12.6463L18.3535 9.64633C18.3071 9.59986 18.252 9.56301 18.1913 9.5379C18.1307 9.51279 18.0657 9.49991 18 9.5H6C5.93433 9.49992 5.86928 9.51281 5.80861 9.53794C5.74794 9.56308 5.69282 9.59995 5.64644 9.64645L2.64644 12.6464C2.6 12.6929 2.56317 12.748 2.53804 12.8087C2.51291 12.8694 2.49999 12.9344 2.50001 13.0001C2.50003 13.0658 2.51299 13.1308 2.53815 13.1915C2.5633 13.2522 2.60017 13.3073 2.64664 13.3537L4.64625 15.3533L4.64667 15.3538L5.5 16.2072V18.5H0V19.5H24V18.5H18.5ZM17.5 18.5H16.2071L17.5 17.207V18.5ZM5.35347 14.6464L4.20711 13.5H8.5V14C8.5 14.1326 8.55268 14.2598 8.64645 14.3536C8.74021 14.4473 8.86739 14.5 9 14.5C9.13261 14.5 9.25979 14.4473 9.35355 14.3536C9.44732 14.2598 9.5 14.1326 9.5 14V13.5H14.5V14C14.5 14.1326 14.5527 14.2598 14.6464 14.3536C14.7402 14.4473 14.8674 14.5 15 14.5C15.1326 14.5 15.2598 14.4473 15.3536 14.3536C15.4473 14.2598 15.5 14.1326 15.5 14V13.5H19.7929L18.6466 14.6463L18.6463 14.6466L14.7929 18.5H9.20711L5.35361 14.6465L5.35347 14.6464ZM6.20711 10.5H8.5V12.5H4.20711L6.20711 10.5ZM17.7929 10.5L19.7929 12.5H15.5V10.5H17.7929ZM14.5 12.5H9.5V10.5H14.5V12.5ZM6.5 17.2072L7.79289 18.5H6.5V17.2072Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

PavementObstruction.defaultProps = {
  altText: "Pavement Obstruction",
  backgroundColor: "#00D2D2",
  foregroundColor: "#000000"
};
PavementObstruction.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = PavementObstruction;
exports.default = _default;